import mixpanel from 'mixpanel-browser'

export default {
  install: (app) => {
    app.config.globalProperties.mixpanel = mixpanel
    app.config.globalProperties.mixpanel.init(`${process.env.VUE_APP_MIXPANEL_TOKEN}`)
  }
}